import { render, staticRenderFns } from "./foundations.vue?vue&type=template&id=04721892"
import script from "./foundations.vue?vue&type=script&lang=js"
export * from "./foundations.vue?vue&type=script&lang=js"
import style0 from "./foundations.vue?vue&type=style&index=0&id=04721892&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports